<template>
  <div class="modal sign-modal">
    <div class="overlay"></div>
    <div class="overlay overlay-invisible" @click="$emit('closeSignIn')"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img class="close" @click="$emit('closeSignIn')" src="./../images/close.svg"/>
            <div :class="['form-fields login-content', {'hidden': !loginContentVisible}]">
              <div class="form-fields-wrapper">
                <div class="title small">
                  SIGN IN 
                  <span class="desc"><b>WITH E-MAIL</b></span>
                </div>
                <div class="modal-bottom">
                  <div class="desc">Don't have an account?</div>
                  <div class="link" @click="$parent.openSignUp">Create one here</div>
                </div>
                <label>
                  <div class="desc">E-mail:</div>
                  <input type="email" placeholder="Email" v-model="email"/>
                </label>
                <label>
                  <div class="desc">Password:</div>
                  <input type="password" placeholder="Password" v-model="pass"/>
                </label>
                <div class="cta-container">
                  <div class="link" @click="switchToforgotPass">Forgot password?</div>
                  <button class="button red" @click="submitLogin">
                    <span>SIGN IN WITH E-MAIL</span>
                  </button>
                  <div class="desc or">or</div>
                  <button class="button steam" @click="$parent.submitLoginSteam">
                    <span>SIGN IN WITH STEAM</span>
                  </button>
                </div>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                </transition>
              </div>
            </div>
            <div :class="['form-fields forgot-pass-content', {'hidden': !forgotPassContentVisible}]">
              <div class="form-fields-wrapper">
                <div class="title small">Forgot password?</div>
                  <div class="modal-bottom">
                  <div class="desc">Have account?</div>
                  <div class="link switch-login" @click="switchToLogin()">Login</div>
                </div>
                <label>
                  <div class="desc">E-mail:</div>
                  <input type="email" placeholder="Email" v-model="email"/>
                </label>
                <div class="cta-container">
                  <button class="button red" @click="submitForgotPass">
                    <span>Recover</span>
                  </button>
                </div>
                <transition name="fade">
                  <div v-if="$parent.successMessage" class="desc green">{{$parent.successMessage}}</div>
                </transition>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Login',
  props: [],
  components: {
  },
  data: function() {
    return {
      loginContentVisible: true,
      forgotPassContentVisible: false,
      email: '',
      pass: ''
    }
  },
  mounted() {
    
  },
  methods: {
    switchToforgotPass() {
      this.$parent.clearError();
      setTimeout(()=> {
        this.loginContentVisible = false;
        this.forgotPassContentVisible = true;
      }, 100)
    },
    switchToLogin() {
      this.$parent.clearError();
      setTimeout(()=> {
        this.forgotPassContentVisible = false;
        this.loginContentVisible = true;
      }, 100)
    },
    submitLogin() {
      let loginData = {
        "username": this.email,
        "password": this.pass
      }
      this.$emit('login', loginData)
    },
    submitForgotPass() {
      let data = {
        "email": this.email
      }
      this.$emit('forgotPass', data)
    },
  }
}
</script>